import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Request } from '../models';
import { CrudBaseService } from '../crud.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class RequestService extends CrudBaseService<Request> {
    constructor(httpClient: HttpClient) {
        super('/request', httpClient);
    }

    approve(id: string): Observable<any> {
        const path = `${this.basePath}/${id}/approve`;
        return this.httpClient.get(path).pipe(map((res) => res));
    }
    reject(id: string): Observable<any> {
        const path = `${this.basePath}/${id}/denied`;
        return this.httpClient.get(path).pipe(map((res) => res));
    }

    requestFP(accountID, requestType, filterString): Observable<any> {
        const path = `${this.basePath}`;
        const params = {
            data: {
                account: accountID,
                request_type_lookup: requestType,
                export_fingerprint: {
                    s3_url: null,
                    filter_condition: filterString
                }
            }
        }
        return this.httpClient.post(path, params).pipe(map((res) => res));
    }
}
